module.exports = __webpack_public_path__ + "static/media/call40.c6322ff0.png";